import { RenderTemplateCallback }                               from "../../src/types";
import {TemplateKeys} from "./render/shared";
import {renderChristmasTemplate} from "./render/christmas";


export const renderTemplate: RenderTemplateCallback = async (ctx, utils, template, data, signatures) => {
   
    const templateKey = template.key as TemplateKeys;

    switch (templateKey) {
        case "Healthcare":
        case "Workwear":
            await renderChristmasTemplate(ctx, utils, template, data, signatures);
            break;
        default:
            alert(`Specified template ${templateKey} has no render function!`);
    }
}